export default {
  // 加载提示
  loading: "拼命加载中",

  // 暂无数据
  noData: "暂无数据",

  // 标题
  pendingSurvey: "待调证",
  completedSurvey: "已调证",

  // 字段标签
  platform: "平台：",
  platformColon: "平台:",
  surveyContent: "调证内容：",
  uid: "UID:",
  name: "姓名：",
  address: "地址：",

  // 按钮
  uploadSurvey: "上传调证",
  downloadSurveyContent: "下载调证内容",
  dataSync: "数据同步",

  // 消息提示
  messageTitle: "消息",
  dataSyncing: "数据同步中，请稍后查看",

  // 文件名
  dataFileName: "数据",
};
